export const reasonsSelector = state => state.reasons.results?.valueSeq()?.toArray()

export const reasonToRefuseServiceOrderList = state =>
  state.reasons.reasonToRefuseServiceOrderList.toArray()
